import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
    textAlign: "center",
    paddingBottom: theme.spacing(2),
  },
  button: {
    '&:disabled': {
      backgroundColor: `${theme.palette.secondary.dark} !important`,
    },
  },
}));
